// extracted by mini-css-extract-plugin
export default {"one-time-code-batch-desc-wrapper":"one-time-code-batch-desc-wrapper_S1RsY"};